﻿import React, { useEffect } from 'react';

import { GenerateReport } from 'components/GenerateReport/GenerateReport';
import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { TileContainer } from 'components/TileContainer/TileContainer';
import { useTransactionDetails } from 'pages/access_codes/context';
import { exportPDF } from 'pages/groups/components/Activity';
import { ReportFilterType } from 'apis/ReportApi';
import { FormattedMessage } from 'react-intl';
import { useJoyride } from 'app/joyride';
import { useSuperState } from 'hooks';
import { useApp } from 'app';

import 'pages/access_codes/components/ActivityTab/styles/activity-tab.scss';

export function ActivityTab() {

    const [state, setState] = useSuperState({
        waitForDataLoad: false
    });
    const { waitForDataLoad } = state;

    const { selectedPartner } = useApp();
    const { pageContext } = useTransactionDetails();
    const { loadCurrentTour } = useJoyride();

    useEffect(() => {

        loadCurrentTour('ReportsTab');
        setTimeout(() => {

            setState({ waitForDataLoad: true });

        }, 500);

    }, []);

    return (
        <>
            <TileContainer
                addButton
                addButtonCustom={(
                    <GMetrixButton
                        iconClass="fa-solid fa-print"
                        onClick={() => exportPDF()}
                        type="button"
                        variant="primary"
                    >
                        <FormattedMessage defaultMessage="Print" id="print.1fd3b13a" />
                    </GMetrixButton>
                )}
            >
                <div id="reportPDF">
                    {waitForDataLoad && pageContext && (
                        <>
                            <GenerateReport
                                propCustomFilter={{
                                    filterId: ReportFilterType.TransactionsCSV,
                                    valueId: pageContext.Id
                                }}
                                autoRunReport={true}
                                removeFilters={['TransactionsCSV', 'StudentGroupsCSV']}
                                reportId={30}
                                scopeId={4}
                                scopeObjectId={selectedPartner.id}
                            />
                        </>
                    )}
                </div>
            </TileContainer>
        </>
    );

}
